/* ------------------------------------------------------------------
   Mr Football - cart gap-closer add-to-cart.

   Powers the "Add one of these to unlock..." buttons rendered by
   snippets/cart-shipping-countdown.liquid.

   Delegated from document, because the cart drawer is re-rendered via
   innerHTML on every cart change - a listener bound directly to the
   buttons would be destroyed on the first update, and an inline <script>
   inside that markup would never execute at all.

   The buttons are type="button" on purpose: they sit INSIDE the cart's
   <form>, so a default-type button would submit the cart instead.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfCartUpsell) { return; }
  window.__mfCartUpsell = true;

  function onCartPage() {
    return /^\/cart(\/|$)/.test(window.location.pathname);
  }

  function refreshDrawer() {
    return fetch('/cart?view=ajax', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (html.indexOf('<!DOCTYPE') === 0) { throw new Error('unexpected full page'); }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var tpl = doc.querySelector('template[data-html="content"]');
        var target = document.querySelector('.js-ajax-cart-content');
        if (!tpl || !target) { throw new Error('no drawer'); }
        target.innerHTML = tpl.innerHTML;

        var opt = doc.querySelector('template[data-options]');
        if (opt) {
          try {
            var o = JSON.parse(opt.innerHTML);
            var counters = document.querySelectorAll('.js-cart-count');
            for (var i = 0; i < counters.length; i++) { counters[i].textContent = o.item_count; }
          } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('mf:cart:updated'));
      });
  }

  document.addEventListener('click', function (e) {
    var node = e.target;
    while (node && node.nodeType !== 1) { node = node.parentNode; }
    var btn = node && node.closest ? node.closest('[data-mf-add]') : null;
    if (!btn) { return; }

    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled) { return; }

    var id = btn.getAttribute('data-mf-add');
    if (!id) { return; }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) { throw new Error('add failed ' + r.status); }
        return r.json();
      })
      .then(function () {
        // On the cart page the drawer is not the source of truth, so reload.
        if (onCartPage()) { window.location.reload(); return null; }
        return refreshDrawer();
      })
      .catch(function () {
        // Never leave the shopper with a dead button.
        btn.disabled = false;
        btn.textContent = label;
      });
  }, true);
})();